module.exports = __webpack_public_path__ + "static/media/Untitled_ Nov 23, 2020 12_55 PM (575 x 480 px).1fd1fdd4.gif";